import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "boundary-plus-upload" }
const _hoisted_2 = {
  key: 1,
  class: "boundary-plus-upload__file-list"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "boundary-plus-upload__file-icon boundary-plus-upload__file-icon--video"
}
const _hoisted_5 = { class: "boundary-plus-upload__file-name" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 2,
  class: "boundary-plus-upload__actions"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "boundary-plus-upload__progress-bar" }, null, -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "boundary-plus-upload__upload-status" }, null, -1 /* HOISTED */)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 3,
  class: "boundary-plus-upload__complete"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "Files uploaded. They will appear in the grid once processed.", -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DragDrop = _resolveComponent("DragDrop")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$data.show_complete_message)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref: "dropzone",
          class: "boundary-plus-upload__dropzone",
          style: _normalizeStyle($data.dropzone_height ? { height: $data.dropzone_height + 'px' } : null)
        }, [
          ($data.uppy)
            ? (_openBlock(), _createBlock(_component_DragDrop, _mergeProps({
                key: 0,
                uppy: $data.uppy
              }, $data.uppy_config), null, 16 /* FULL_PROPS */, ["uppy"]))
            : (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: "boundary-plus-upload__loading",
                style: _normalizeStyle($data.dropzone_height ? { height: '100%', minHeight: 'unset' } : null)
              }, " Loading uploader… ", 4 /* STYLE */))
        ], 4 /* STYLE */))
      : _createCommentVNode("v-if", true),
    ($options.uppy_files.length && !$data.show_complete_message)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.uppy_files, (file) => {
            return (_openBlock(), _createElementBlock("div", {
              key: file.id,
              class: "boundary-plus-upload__file"
            }, [
              ($data.files[file.id] && $data.files[file.id].preview)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: $data.files[file.id].preview,
                    class: "boundary-plus-upload__file-preview",
                    alt: ""
                  }, null, 8 /* PROPS */, _hoisted_3))
                : (_openBlock(), _createElementBlock("div", _hoisted_4)),
              _createElementVNode("p", _hoisted_5, _toDisplayString(file.meta.name), 1 /* TEXT */),
              _createElementVNode("button", {
                class: "boundary-plus-upload__file-remove",
                "aria-label": "Remove file",
                onClick: $event => ($options.removeFile( file.id ))
              }, null, 8 /* PROPS */, _hoisted_6)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    ($options.uppy_files.length && !$data.uploading && !$data.show_complete_message)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "button button--large",
            onClick: _cache[0] || (_cache[0] = (...args) => ($options.submitUpload && $options.submitUpload(...args)))
          }, " Upload " + _toDisplayString($options.uppy_files.length) + " file" + _toDisplayString($options.uppy_files.length === 1 ? '' : 's'), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass(["boundary-plus-upload__progress", { 'invisible': !$data.uploading }])
    }, _hoisted_10, 2 /* CLASS */),
    ($data.show_complete_message)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("button", {
            class: "button button--large",
            onClick: _cache[1] || (_cache[1] = (...args) => ($options.reset && $options.reset(...args)))
          }, " Upload more ")
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}